<template>
  <div>
    <v-row class="justify-center">
      <v-col
        cols="12"
        class="text-h6 font-weight-normal py-2 pt-4"
      >
        รายละเอียดแพ็กเกจ
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="12">
        <div class="primary white--text text-h6 text-center font-weight-bold pa-4">
          OA Chat Package
        </div>
      </v-col>
    </v-row>
    <v-row class="justify-center mb-4">
      <v-col
        cols="6"
        class="text-body text-center"
      >
        รายเดือน
      </v-col>
      <v-col
        cols="6"
        class="text-body text-center"
      >
        555 บาท / เดือน
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="justify-center my-4">
      <v-col
        cols="6"
        class="text-body text-center"
      >
        ประวัติการเก็บข้อมูลการแชท
      </v-col>
      <v-col
        cols="6"
        class="text-body text-center"
      >
        5 ปี
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="justify-center my-4">
      <v-col
        cols="6"
        class="text-body text-center"
      >
        ดาวน์โหลดประวัติการแชท
      </v-col>
      <v-col
        cols="6"
        class="text-body text-center"
      >
        มี
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="justify-center my-1">
      <v-col
        cols="6"
        class="text-body text-center align-center mt-5"
      >
        จำนวนแท็กที่สามารถสร้างได้
      </v-col>
      <v-col
        cols="6"
        class="text-body text-center pa-5"
      >
        <div>สูงสุด 300 แท็ก</div>
        <div>สูงสุด 30 แท็กต่อแชท</div>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="justify-center my-4">
      <v-col
        cols="6"
        class="text-body text-center"
      >
        จำนวนโน้ตที่สามารถสร้างได้
      </v-col>
      <v-col
        cols="6"
        class="text-body text-center"
      >
        สูงสุด 1,000 โน้ตต่อแชท
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="justify-center my-4">
      <v-col
        cols="6"
        class="text-body text-center"
      >
        ฟิลเตอร์ที่กำหนดเอง (Upcoming)
      </v-col>
      <v-col
        cols="6"
        class="text-body text-center"
      >
        มี
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div
      class="_fs-14 pa-4 text-center"
      :class="{ 'error--text': true }">
      * ราคาดังกล่าวไม่รวมภาษีมูลค่าเพิ่ม 7%
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderOaChatDetailTable',
  props: {},
  methods: {}
}
</script>
